import { render } from "./CustomerStatement.vue?vue&type=template&id=207d2f6c&scoped=true"
import script from "./CustomerStatement.vue?vue&type=script&lang=js"
export * from "./CustomerStatement.vue?vue&type=script&lang=js"

import "./CustomerStatement.vue?vue&type=style&index=0&id=207d2f6c&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207d2f6c"]])

export default __exports__